import React from 'react';
import DetailItem from 'components/Layout/DetailItem';
import { handleFileDownload } from 'utils/helpers';
import moment from 'moment';

const RequestSection = ({ title, fields = [] }) => {
  return (
    <>
      <div className="text-14-500-18 color-text-blue cmb-16">{title} :</div>
      <div className="row">
        {fields.map((field, index) => {
          const {
            label,
            value,
            type = 'text',
            colClass = 'col-md-3 col-sm-6 col-12',
            filePath,
            labelClassName,
            isDate = false,
          } = field;

          let displayValue = value;
          if (isDate && value) {
            displayValue = moment(value).format('DD-MMM-YYYY');
          }

          return (
            <div className={colClass} key={index}>
              <DetailItem
                label={label}
                value={displayValue}
                type={type}
                fileName={type === 'url' ? value : undefined}
                handleFileDownload={type === 'url' ? handleFileDownload : undefined}
                filePath={filePath}
                labelClassName={labelClassName}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default RequestSection;
